import React from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faObjectsAlignBottom,
  faObjectsAlignCenterVertical,
  faObjectsAlignTop,
} from "@fortawesome/pro-regular-svg-icons";
import type { Column } from "../../domain/types";

type VerticalAlign = Column["verticalAlign"];

const VERTICAL_ALIGN_OPTIONS = [
  { align: "top", icon: faObjectsAlignTop, label: "Top" },
  { align: "middle", icon: faObjectsAlignCenterVertical, label: "Center" },
  { align: "bottom", icon: faObjectsAlignBottom, label: "Bottom" },
] as const satisfies ReadonlyArray<{
  align: VerticalAlign;
  icon: typeof faObjectsAlignTop;
  label: string;
}>;

export function VerticalAlignField({
  value,
  onChange,
}: {
  value: VerticalAlign;
  onChange: (value: VerticalAlign) => void;
}) {
  const { t } = useTranslation();

  return (
    <div
      className="email-builder-settings-segment-wide email-builder-settings-segment-wide--with-icons"
      role="radiogroup"
      aria-label={t("Alignment")}
    >
      {VERTICAL_ALIGN_OPTIONS.map(option => (
        <button
          key={option.align}
          type="button"
          role="radio"
          aria-checked={value === option.align}
          aria-label={t(option.label)}
          data-on={value === option.align ? "true" : "false"}
          onClick={() => onChange(option.align)}
        >
          <FontAwesomeIcon icon={option.icon} aria-hidden="true" />
        </button>
      ))}
    </div>
  );
}
